export default __webpack_public_path__ + "static/media/home17.241fbdc5.jpg";